<template>
  <div>
    <div class="dateTab">
      <input
        type="text"
        placeholder="所供产品"
        autocomplete="off"
        style="
          float: left;
          border: 1px solid #ebebeb;
          outline: none;
          padding: 10px;
          width: 150px;
          height: 34px;
          box-sizing: border-box;
          margin-right: 10px;
        "
        v-model="conditions.production"
      />
      <!--车企筛选-->
      <select-letter
        v-model="conditions.manufacturer"
        :width="80"
        position="right:-544px"
        text="车企"
        :options="options.manufacturer_options"
        @reset="conditions_init('manufacturer')"
        :key="'manufacturer' + component_key"
      />
      <!--品牌筛选-->
      <select-letter
        v-model="conditions.brand"
        :width="80"
        position="right:-436px"
        text="品牌"
        :options="options.brand_options"
        @reset="conditions_init('brand')"
        :key="'brand' + component_key"
      />
      <!--车系筛选-->
      <select-group
        v-model="conditions.model"
        :width="80"
        position="right:-468px"
        text="车系"
        :options="options.model_options"
        @reset="conditions_init('model')"
        :key="'model' + component_key"
      />

      <select-input
        v-model="conditions.programCode"
        :options="options.programCode_options"
        :key="'programCode' + component_key"
      />
    </div>

    <div class="countChart" style="padding-bottom: 20px">
      <div class="charTitle">
        <div class="title">请输入您公司所供产品、配套项目后开始计算</div>
        <div class="chartIcon">
          <ul>
            <li :class="series_type === `table` ? `chartcur` : ``">
              <a href="javascript:;" class="icon1" @click="switch_chart(`table`)"></a>
            </li>
            <li :class="series_type === `line` ? `chartcur` : ``">
              <a href="javascript:;" class="icon2" @click="switch_chart(`line`)"></a>
            </li>
            <li :class="series_type === `bar` ? `chartcur` : ``">
              <a href="javascript:;" class="icon3" @click="switch_chart(`bar`)"></a>
            </li>
          </ul>
          <span>
            <a href="javascript:;" class="icon4" @click="excel"></a>
          </span>
        </div>
      </div>

      <div>
        <div class="countForm" v-show="series_type === `table`">
          <table cellpadding="0" cellspacing="0" border="0" width="100%" id="dataTable">
            <tbody>
              <tr>
                <th class="firstTab">值/年</th>
                <th v-for="(value, index) in dates" :key="index">
                  {{ value }}
                </th>
                <th>合计</th>
              </tr>
              <tr>
                <td class="firstTab">项目单年出货量(件)</td>
                <td v-for="(value, index) in table.shipment" :key="index">
                  <input
                    type="number"
                    v-model="table.shipment[index]"
                    :style="
                      table.shipment[index] === table.forecast[index]
                        ? `color: #00578F;caret-color: black;`
                        : ``
                    "
                    :readonly="index === table.shipment.length - 1 ? `readonly` : false"
                  />
                </td>
              </tr>
              <tr>
                <td class="firstTab">项目零件数量(件)</td>
                <td v-for="(value, index) in table.partsNum" :key="index">
                  <input
                    type="number"
                    v-model="table.partsNum[index]"
                    :readonly="index === table.partsNum.length - 1 ? `readonly` : false"
                  />
                </td>
              </tr>
              <tr>
                <td class="firstTab">用户企业份额占比(%)</td>
                <td v-for="(value, index) in table.share" :key="index">
                  <input
                    type="number"
                    v-model="table.share[index]"
                    :readonly="index === table.share.length - 1 ? `readonly` : false"
                  />
                </td>
              </tr>
              <tr>
                <td class="firstTab">单产品销售价格(元)</td>
                <td v-for="(value, index) in table.price" :key="index">
                  <input
                    type="number"
                    v-model="table.price[index]"
                    :readonly="index === table.price.length - 1 ? `readonly` : false"
                  />
                </td>
              </tr>
              <tr>
                <td class="firstTab">产值(元)</td>
                <td v-for="(value, index) in table.value" :key="index">
                  <input
                    type="number"
                    step="0.01"
                    v-model="table.value[index]"
                    readonly="readonly"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <p><span>蓝色</span>表示盖世预测数据</p>
        </div>

        <calculate-charts
          v-if="series_type !== `table`"
          :width="960"
          :height="360"
          :time_data="dates"
          :volume_data="table"
          :series_type="series_type"
        />

        <div class="countBut">
          <a
            href="javascript:;"
            :class="btn.calculate ? `begincount` : ``"
            @click="calculate"
            >开始计算</a
          >
          <a href="javascript:;" class="begincount" v-show="btn.save" @click="save"
            >保存</a
          >
          <a href="javascript:;" v-show="btn.clear" @click="clear">清空</a>
        </div>
      </div>
    </div>

    <div class="detailData">
      <div class="charTitle">
        <div class="title">产值管理</div>
        <download
          url="/excel/ExportUserCalculationLog"
          :params="{}"
          :words="['产值管理']"
        />
      </div>

      <div class="detailshow">
        <a href="javascript:;" class="editDate" v-if="page.total === 0">请编辑计算内容</a>

        <div class="dtDLeft" v-if="page.total > 0">
          <div class="dataForm">
            <table cellpadding="0" cellspacing="0" border="0" width="100%">
              <tr>
                <th>所供产品</th>
                <th>车企</th>
                <th>品牌</th>
                <th>车系</th>
                <th>项目代号</th>
                <th>产品生命周期</th>
                <th v-for="(value, index) in dates" :key="index">
                  {{ value }}
                </th>
                <th>删除</th>
                <th>编辑</th>
              </tr>
              <tr
                v-for="(item, index) in value_list.userCalculationLognlist"
                :key="index"
              >
                <td v-text="item.production ? item.production : `-`"></td>
                <td v-text="item.manufacturer ? item.manufacturer : `-`"></td>
                <td v-text="item.brand ? item.brand : `-`"></td>
                <td v-text="item.model ? item.model : `-`"></td>
                <td v-text="item.projectCode ? item.projectCode : `-`"></td>
                <td v-text="item.lifeCycle ? item.lifeCycle : `-`"></td>
                <td
                  v-for="(items, index) in item.valueContents"
                  v-text="items ? items : `-`"
                  :key="index"
                ></td>
                <td class="editBut">
                  <a href="javascript:;" class="delIcon" @click="delete_value(item)"></a>
                </td>
                <td class="editBut">
                  <a href="javascript:;" class="editIcon" @click="edit_value(item)"></a>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>

    <confirm-dialog ref="confirm_dialog">{{ dialog_text }}</confirm-dialog>

    <!--通知框-->
    <div v-if="success">
      <div class="blackLayerbg"></div>
      <div class="submitLayer">
        <div class="closeIcon">
          <a href="javascript:;" @click="success = false"></a>
        </div>
        <em></em>
        <p>保存成功</p>
      </div>
    </div>
  </div>
</template>

<script>
import SelectLetter from "@/components/select/select-letter";
import SelectInput from "@/components/select/select-input";
import SelectGroup from "@/components/select/select-group";
import Download from "@/components/download";
import CalculateCharts from "@/components/echarts/calculate-charts";
import ConfirmDialog from "@/components/dialog";
import XLSX from "xlsx";

export default {
  name: "calculate",
  components: {
    SelectLetter,
    SelectInput,
    SelectGroup,
    Download,
    CalculateCharts,
    ConfirmDialog,
  },
  metaInfo() {
    return {
      title: "产值计算-盖亚系统",
      meta: [
        {
          name: "keywords",
          content: "产值计算",
        },
        {
          name: "description",
          content:
            "产值计算：用户选择车企的整车项目代号，获得我们提供的预测产量，或输入一些数值，可获取自己公司的年产值等。",
        },
      ],
    };
  },
  data() {
    return {
      dates: [],
      date_count: 8, // 时间个数
      options: {
        manufacturer_options: [],
        brand_options: [],
        model_options: [],
        programCode_options: [],
      },
      conditions: {
        production: "",
        manufacturer: "",
        brand: "",
        model: "",
        programCode: "",
      },
      table: {
        shipment: new Array(9),
        partsNum: new Array(9),
        share: new Array(9),
        price: new Array(9),
        value: new Array(9),
        forecast: new Array(9),
      },
      btn: {
        calculate: false,
        save: false,
        clear: false,
      },
      page: {
        index: 1,
        size: 10,
        total: 0,
      },
      series_type: "table",
      value_list: [],
      dialog_text: "",
      success: false,
      component_key: 0,
    };
  },
  watch: {
    table: {
      handler() {
        let _this = this;
        _this.btn.save = false;
        _this.btn.clear = false;
        for (let i = 0; i < _this.date_count; i++) {
          // 保存
          if (_this.table.value[i] !== undefined) {
            _this.btn.save = true;
          }
          // 清空
          if (
            _this.table.shipment[i] ||
            _this.table.partsNum[i] ||
            _this.table.share[i] ||
            _this.table.price[i]
          ) {
            _this.btn.clear = true;
          }
          // 开始计算
          if (
            _this.table.shipment[i] &&
            _this.table.partsNum[i] &&
            _this.table.share[i] &&
            _this.table.price[i]
          ) {
            _this.btn.calculate = true;
            return false;
          }
        }
        _this.btn.calculate = false;
        _this.btn.save = false;
      },
      deep: true,
    },
  },
  mounted() {
    this.date_init();
    this.conditions_init();
    this.values();
  },
  methods: {
    date_init() {
      let _this = this;
      for (let i = 0; i < _this.date_count; i++) {
        _this.dates.push(new Date().getFullYear() + i);
      }
    },
    conditions_init(condition) {
      let _this = this;
      switch (condition) {
        case "brand_origin":
        case "body_size":
        case "propulsion_type":
          _this.conditions.manufacturer = 0;
          _this.conditions.brand = 0;
          _this.conditions.model = "";
          break;
        case "manufacturer":
          _this.conditions.brand = 0;
          _this.conditions.model = "";
          break;
        case "brand":
          _this.conditions.model = "";
      }
      this.$http({
        url: "/outputvalue/condition",
        method: "get",
        crossdomain: true,
        params: {
          manufacturerId: _this.conditions.manufacturer,
          brandId: _this.conditions.brand,
          model: _this.conditions.model,
          programCode: _this.conditions.programCode,
        },
      })
        .then(function (res) {
          _this.options.manufacturer_options = res.data.manufacturers;
          _this.options.brand_options = res.data.brands;
          _this.options.model_options = res.data.modelLines;
          _this.options.programCode_options = res.data.programCodes;
          if (res.data.forecasts.length > 0) {
            _this.table.forecast = new Array(9);
            _this.table.shipment = new Array(9);
            res.data.forecasts.forEach((element, index) => {
              _this.table.forecast[index] = element.volume;
              _this.table.shipment[index] = element.volume;
            });
          }
          console.log(_this.table.shipment);
          console.log(_this.table.forecast);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    values() {
      let _this = this;
      this.$http({
        url: "/GetUserCalculationLog",
        method: "get",
        crossdomain: true,
        params: {
          userID: _this.$store.state.userId,
          pageindex: _this.page.index,
          pagesize: _this.page.size,
        },
      }).then(function (res) {
        _this.value_list = res.data;
        _this.page.total = res.data.pageCount;
      });
    },
    calculate() {
      if (this.$store.state.userId === 0) {
        window.location.href = this.$store.state.login_url;
        return false;
      }
      let _this = this;
      if (!_this.btn.calculate) return false;
      for (let i = 0; i < _this.date_count; i++) {
        if (
          _this.table.shipment[i] &&
          _this.table.partsNum[i] &&
          _this.table.share[i] &&
          _this.table.price[i]
        ) {
          _this.table.value.splice(
            i,
            1,
            (
              _this.table.shipment[i] *
              _this.table.partsNum[i] *
              parseFloat(_this.table.share[i] / 100) *
              _this.table.price[i]
            ).toFixed(2)
          );
        }
      }
      _this.btn.save = true;
    },
    save() {
      if (!this.conditions.production) {
        this.dialog_text = "请输入所供产品";
        this.$refs.confirm_dialog.init(() => {}, true);
        return false;
      }

      if (!this.conditions.model && !this.conditions.programCode) {
        this.dialog_text = "请选择车系或填写项目代号";
        this.$refs.confirm_dialog.init(() => {}, true);
        return false;
      }

      let _this = this;
      let formData = new FormData();
      formData.append("userID", _this.$store.state.userId);
      formData.append("production", _this.conditions.production);
      formData.append(
        "brand",
        _this.options.brand_options.find((o) => o.brandId === _this.conditions.brand)
          .brandName
      );
      formData.append(
        "manufacturer",
        _this.options.manufacturer_options.find(
          (o) => o.manufacturerId === _this.conditions.manufacturer
        ).vehicleManufacturer
      );
      formData.append("model", _this.conditions.model);
      formData.append("projectCode", _this.conditions.programCode);
      formData.append("contents", JSON.stringify(_this.table.value));
      formData.append("shipment", JSON.stringify(_this.table.shipment));
      formData.append("spareParts", JSON.stringify(_this.table.partsNum));
      formData.append("proportion", JSON.stringify(_this.table.share));
      formData.append("salePrice", JSON.stringify(_this.table.price));
      formData.append("mID", _this.conditions.manufacturer);
      formData.append("bID", _this.conditions.brand);
      formData.append("modelId", _this.conditions.model);
      this.$http
        .post("/PostUserCalculationLog", formData)
        .then(function () {
          _this.success = true;
          setTimeout(() => {
            _this.success = false;
          }, 1500);
          _this.page.index = 1;
          _this.values();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    clear() {
      this.dialog_text = "确认清空当前计算器内容?";
      this.$refs.confirm_dialog.init(() => {
        this.table = {
          shipment: new Array(9),
          partsNum: new Array(9),
          share: new Array(9),
          price: new Array(9),
          value: new Array(9),
        };
        this.switch_chart(`table`);
      });
    },
    delete_value(item) {
      const _this = this;
      this.dialog_text = "确认删除这条数据?";
      this.$refs.confirm_dialog.init(() => {
        this.$http({
          url: "/DeleteInfoById",
          method: "Post",
          crossdomain: true,
          params: {
            id: item.id,
          },
        })
          .then(function () {
            _this.page.index = 1;
            _this.values();
          })
          .catch(function (error) {
            console.log(error);
          });
      });
    },
    edit_value(item) {
      const _this = this;
      this.$http({
        url: "/GetInfoById",
        method: "get",
        crossdomain: true,
        params: {
          id: item.id,
        },
      })
        .then(function (response) {
          _this.table = {
            shipment: new Array(9),
            partsNum: new Array(9),
            share: new Array(9),
            price: new Array(9),
            value: new Array(9),
          };
          _this.switch_chart(`table`);
          for (let i = 0; i < 8; i++) {
            _this.table.shipment.splice(i, 1, response.data.shipment[i]);
            _this.table.partsNum.splice(i, 1, response.data.spareParts[i]);
            _this.table.share.splice(i, 1, response.data.proportion[i]);
            _this.table.price.splice(i, 1, response.data.salePrice[i]);
            // _this.table.value.splice(i, 1, response.data.contents[i]);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    switch_chart(char_type) {
      this.series_type = char_type;
    },
    excel() {
      let data = [];
      let raw = [];
      // 表头
      raw.push(`值/年`);
      this.dates.forEach((element) => {
        raw.push(element);
      });
      raw.push(`合计`);
      data.push(raw);

      raw = [];
      raw.push(`项目单年出货量`);
      this.table.shipment.forEach((element) => {
        raw.push(element);
      });
      data.push(raw);

      raw = [];
      raw.push(`项目零件数量`);
      this.table.partsNum.forEach((element) => {
        raw.push(element);
      });
      data.push(raw);

      raw = [];
      raw.push(`用户企业份额占比(%)`);
      this.table.share.forEach((element) => {
        raw.push(element);
      });
      data.push(raw);

      raw = [];
      raw.push(`单产品销售价格`);
      this.table.price.forEach((element) => {
        raw.push(element);
      });
      data.push(raw);

      raw = [];
      raw.push(`产值`);
      this.table.value.forEach((element) => {
        raw.push(element);
      });
      data.push(raw);

      const ws = XLSX.utils.aoa_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, `Sheet1`);
      /* save to file */
      XLSX.writeFile(wb, `产值计算` + `.xlsx`);
    },
  },
};
</script>
